export const breadcrumbStyles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 1,
  },

  item: {
    display: 'flex',
    alignItems: 'center',
  },

  link: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: 'text.secondary',
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      color: 'primary.main',
      textDecoration: 'underline',
    },
  },

  current: {
    fontSize: '0.875rem',
    fontWeight: 600,
    color: 'primary.main',
  },

  separator: {
    mx: 1,
    color: 'grey.400',
    fontSize: '0.875rem',
  },
};
